import { useEffect, useState } from "react";
import { getGoldenNew } from "@/lib/golden";
import { useAuth, isMember } from "@/lib/auth";

export const GoldenNewBadge = () => {
  const { user } = useAuth() || {};
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!isMember(user)) return;
    const load = () => getGoldenNew().then(setN).catch(() => setN(0));
    load();
    window.addEventListener("pp-golden-changed", load);
    return () => window.removeEventListener("pp-golden-changed", load);
  }, [user]);
  if (!n) return null;
  return <span className="pp-new-badge" data-testid="golden-new-badge">{n} New!</span>;
};
